export default __webpack_public_path__ + "static/media/105.1d0d3c9e.jpg";